import styled from 'styled-components';
import Button from '~components/Button';
import { media } from '~constants/media';

// export const GreenButton = styled(Button)`
//   background-color: #7db828;
//   padding: 17px 60px;
//   color: white;
//   font-size: 15px;
//   border: none;

//   &:hover,
//   &:focus {
//     background-color: #78c810;
//   }
// `;

export const GreenButton = styled(Button)`
  background-color: #7db828;
  padding: 0px 22px;
  height: 39px;
  color: white;
  font-size: 13px;
  line-height: 15px;

  &:hover,
  &:focus {
    background-color: #78c810;
  }

  @media (max-width: 320px) {
    padding: 0 12px;
  }

  ${media.lg`
      height: 46px;
      font-size: 17px;
      line-height: 19px;
    `}
`;
